import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

export const styles = makeStyles(() =>
  createStyles({
    logo: {
      cursor: "pointer",
      width: "109px",
      height: "auto"
    }
  })
);

export default styles;
